import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  { q: "What services do you provide?", a: "Web development, full-stack web apps, AI integrations (chatbots, ML, NLP), e-commerce, SaaS products, UI/UX design, custom software and ongoing maintenance." },
  { q: "How long does a project take?", a: "A 5–8 page website typically takes 2–3 weeks. A custom web app or SaaS module ranges from 4–10 weeks depending on scope. We share a clear timeline after the discovery call." },
  { q: "How much do your services cost?", a: "Starter sites begin at $199. Professional apps land in the $499–$899 range. Enterprise / AI products start at $1,199+. Final pricing is shaped by scope and integrations. All prices in USD." },
  { q: "Can you integrate AI into my existing website?", a: "Absolutely — we add Claude, GPT, Gemini or custom NLP into existing stacks: support chatbots, semantic search, content generation, automation. We work with your current backend or replace it." },
  { q: "What technologies do you work with?", a: "React, Next.js, Vue, FastAPI, Node.js, MongoDB, PostgreSQL, Tailwind, Three.js, Razorpay, Stripe, OpenAI, Claude, Gemini — and more." },
  { q: "Do you provide maintenance after launch?", a: "Yes. Every plan includes a support window. We also offer monthly retainers for updates, monitoring, performance tuning and feature work." },
  { q: "How do we start?", a: "Send a message via the contact form, WhatsApp or Telegram. CODER replies within 24 hours and books a free 30-minute discovery call." },
];

export default function FAQ() {
  return (
    <section data-testid="faq-section" className="relative py-32 lg:py-44 px-6 lg:px-10 border-t border-nova-line">
      <div className="max-w-5xl mx-auto">
        <div className="mb-16">
          <div className="mono-label mb-4">[ 06 — FAQs ]</div>
          <h2 className="font-display font-bold tracking-tighter text-4xl lg:text-6xl text-nova-text leading-[0.95]">
            Questions, answered.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-nova-line"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-display text-xl lg:text-2xl text-nova-text hover:text-nova-gold py-7 text-left hover:no-underline tracking-tight">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-nova-mute text-base lg:text-lg leading-relaxed pb-7 max-w-3xl">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-16 flex flex-wrap items-center gap-3">
          <span className="text-nova-mute">Still have questions?</span>
          <a href="#contact" data-testid="faq-contact-cta" className="inline-flex items-center gap-2 text-nova-gold hover:underline underline-offset-4">
            Get in touch →
          </a>
        </div>
      </div>
    </section>
  );
}
